<template>
    <div class="block-editor send-email">
        <div class="wrapper" :key="`dynamic_${clone.isDynamic}`">
            <div class="title">Select Reservation</div>
            <a-select show-search v-model="clone.reservationPlanId">
                <a-select-option
                    v-for="(reservationPlan, index) of reservationPlans"
                    :key="index"
                    :value="reservationPlan._id"
                >
                    {{ reservationPlan.title }}
                </a-select-option>
            </a-select>
            <div class="form-input" v-if="clone.reservationPlanId">
                <div class="form-input-name">Dynamic Reservation</div>
                <a-switch v-model="clone.isDynamic" />
            </div>
            <div class="form-input" v-if="clone.isDynamic && clone.reservationPlanId">
                <div class="form-input-name">Reservation Date</div>
                <TiptapEditor :show-attributes="true" :show-emoji="false" v-model="clone.startDate" />
            </div>
            <div class="form-input" v-if="!clone.isDynamic && clone.reservationPlanId">
                <div class="form-input-name">Reservation Day</div>
                <TiptapEditor :show-attributes="true" :show-emoji="false" v-model="clone.selectedDay" />
            </div>
            <div class="form-input" v-if="!clone.isDynamic && clone.reservationPlanId">
                <div class="form-input-name">Reservation Hour</div>
                <TiptapEditor :show-attributes="true" :show-emoji="false" v-model="clone.selectedTime" />
            </div>
            <div v-for="formInput in formInputs" class="form-input">
                <div class="form-input-name">{{ formInput.label }}</div>
                <TiptapEditor :show-attributes="true" :show-emoji="false" v-model="formInput.value" />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";
import { CALENDAR_API } from "../../../../../../api/calendar";

const log = log2("CreateReservation");
export default {
    name: "CreateReservation",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            reservationPlans: [],
            formInputs: [],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({}),
    },
    mounted() {
        console.log("getReservationList value...", this.value);
        this.formInputs = this.clone.formValues;
        CALENDAR_API.getAllReservationList().then((res) => {
            this.reservationPlans = res;
            if (!this.clone.reservationPlanId) {
                this.formInputs = this.reservationPlans.find(
                    (item) => item._id === this.clone.reservationPlanId
                ).formInputs;
            }
        });
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.reservationPlanId"(val) {
            this.formInputs = this.reservationPlans.find((item) => item._id === val).formInputs;
        },
        formInputs: {
            handler(val) {
                this.clone.formValues = val;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.block-editor.send-email {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0;
            border: 1px solid #fff;
            background: white;
        }

        .form-input {
            margin-top: 10px;

            .form-input-name {
                margin-left: 5px;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
            }
        }
    }
}
</style>
